import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import ".././../styles/diet/diet.css";
import MealsStructure from "../../components/diet/meal/MealsStructure";
import DTFilters from "../../components/diet/diet-timings/DTFilters";
import DTTable from "../../components/diet/diet-timings/DTTable";
import { selectAuth } from "../../components/auth/auth.selector";
import { fetchDietTimingsData } from "../../redux/reducers/apiSlice";
import HelmetWrapper from "../../HelmetWrapper";

const DietTimings = () => {
  const dispatch = useDispatch();
  const { dietTimingsData } = useSelector((state) => state.api);
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const initialDTfilters = {
    searchString: "",
  };
  const [dtFilters, setDTFilters] = useState(initialDTfilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [sendableQPs, setSendableQPs] = useState("");
  const initialDT = {
    isPage: 0,
    pagination: [],
    allDietTiminsData: [],
  };
  const [allDTs, setAllDTs] = useState(initialDT);

  const onClickSearch = () => {
    setSendableQPs((prevs) => {
      const params = new URLSearchParams(prevs);
      params.set("search", dtFilters.searchString);
      return `&${params.toString()}`;
    });

    setSearchFilterApplied(true);

    // setSearchFilterApplied(true);
    // const searchQP = dtFilters.searchString
    //   ? `&search=${dtFilters.searchString}`
    //   : "";

    // setSendableQPs((prevQP) => prevQP + searchQP);
  };

  useEffect(() => {
    dispatch(
      fetchDietTimingsData({
        pageNo: allDTs.isPage + 1,
        limit: 10,
        queryParameters: sendableQPs,
        token: decryptedText?.token,
      })
    );
  }, [sendableQPs, allDTs.isPage]);

  useEffect(() => {
    if (dtFilters.searchString?.length === 0) {
      dispatch(
        fetchDietTimingsData({
          pageNo: 1,
          limit: 10,
          queryParameters: sendableQPs?.replace(/&?name=[^&]*/, ""),
          token: decryptedText?.token,
        })
      );
      setSearchFilterApplied(false);
    }
  }, [dtFilters.searchString]);

  useEffect(() => {
    if (dietTimingsData?.status && dietTimingsData?.data?.length > 0) {
      const { data, pagination } = dietTimingsData || {};

      setAllDTs({
        ...allDTs,
        allDietTiminsData: data || [],
        pagination: pagination || [],
      });
    } else {
      setAllDTs({
        ...allDTs,
        allDietTiminsData: [],
        pagination: [],
      });
    }
  }, [dietTimingsData]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  useEffect(() => {
    if (dtFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setSendableQPs((prevs) => {
        const params = new URLSearchParams(prevs);
        params.delete("search");
        return `&${params.toString()}`;
      });
    }
  }, [dtFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Diet Timings">
      <Container className="bg-cloud-k dietMealsParentContainer px-50px" fluid>
        <Row>
          <Col>
            <MealsStructure text={"All Diet timings"} />
          </Col>
        </Row>
        <Row>
          <Col>
            <DTFilters
              filters={dtFilters}
              setFilters={setDTFilters}
              searchFilterApplied={searchFilterApplied}
              onClickSearch={onClickSearch}
              callFunction={() =>
                dispatch(
                  fetchDietTimingsData({
                    pageNo: 1,
                    limit: 10,
                    queryParameters: sendableQPs,
                    token: decryptedText?.token,
                  })
                )
              }
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <DTTable
              decryptedText={decryptedText}
              allDatas={allDTs}
              setAllDatas={setAllDTs}
              callFunction={() => {
                dispatch(
                  fetchDietTimingsData({
                    pageNo: 1,
                    limit: 10,
                    queryParameters: sendableQPs,
                    token: decryptedText?.token,
                  })
                );
              }}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default DietTimings;
